// A Link-shipments row's discrepancy sections — the shipment mirror of contractDiscrepancy.js.
export const buildShipmentDiscrepancySections = (t, shipment, unitType) => {
  if (!shipment) return [];
  const quantities = shipment.byUnit?.[unitType ?? shipment.unitType] ?? {};

  return [
    {
      title: t('SECTION_GENERAL_DETAILS'),
      fields: [
        { label: t('FIELD_MATERIAL_NAME'), value: shipment.materialName },
        { label: t('FIELD_SENT_BY'), value: shipment.supplierName },
        { label: t('FIELD_RECEIVED_AT'), value: shipment.facilityName },
        { label: t('FIELD_TERMINAL'), value: shipment.terminal },
      ],
    },
    {
      title: t('SECTION_QUANTITY'),
      fields: [
        {
          label: t('FIELD_SHIPMENT_QUANTITY'),
          value: quantities.shipmentQuantity,
        },
        {
          label: t('FIELD_RECEIVED_DECLARATION_QUANTITY'),
          value: quantities.receivedDeclarationQuantity,
        },
        {
          label: t('FIELD_AVAILABLE_QUANTITY'),
          value: quantities.availableQuantity,
        },
      ],
    },
  ];
};
